import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Vote} from '@services/model/vote';
import {ConfigService} from '@services/infra/config.service';
import {map, timeout} from 'rxjs/operators';
import {VoteResource} from '@services/resource/vote-resource';
import {ErrorService} from '@services/error.service';
import {ClientConfig} from '@app/client-config';
import {UUID} from '@util/types';
import {VoteAndCompany} from '@services/model/vote-and-company';
import {MyVotesResource} from '@services/resource/my-votes-resource';
import {ExcelDownloadResponse} from '@services/resource/excel-download-response';

@Injectable({
  providedIn: 'root',
})
export class VoteService {
  constructor(
    private readonly errors: ErrorService,
    private readonly conf: ConfigService,
    private readonly http: HttpClient,
  ) {}

  /* use only for HPs and MA */
  public getVotes(cycleId: UUID, productId?: UUID, companyId?: UUID): Observable<VoteAndCompany[]> {
    const url = `${this.conf.backendUrl}/v1/vote`;
    let params = new HttpParams().set('cycleId', cycleId);
    if (productId) {
      params = params.set('productId', productId);
    }
    if (companyId) {
      params = params.set('companyId', companyId);
    }

    return this.http.get<VoteAndCompany[]>(url, {params}).pipe(timeout(ClientConfig.timeout), this.errors.withErrorHandler());
  }

  public getVotesForOwnProduct(cycleId: UUID, productId: UUID): Observable<MyVotesResource> {
    const url = `${this.conf.backendUrl}/v1/vote/${cycleId}/${productId}`;
    return this.http.get<MyVotesResource>(url);
  }

  public castVote(cycleId: UUID, productId: UUID, companyId: UUID, verdict: number): Observable<Vote> {
    const url = `${this.conf.backendUrl}/v1/vote/${cycleId}/${productId}/${companyId}`;
    return this.http.put<VoteResource>(url, {verdict}).pipe(
      map((vr) => Vote.fromResource(vr)),
      timeout(ClientConfig.timeout),
      this.errors.withErrorHandler(),
    );
  }

  public generateExport(cycleId: UUID): Observable<ExcelDownloadResponse> {
    const url = `${this.conf.backendUrl}/v1/vote/${cycleId}/export`;
    return this.http.post<ExcelDownloadResponse>(url, null);
  }
}
